import { Component, Input, OnInit } from '@angular/core';
import { ConsumerModel } from '@bo-client/activation-management/grid-registration/model/consumer.model';

@Component({
  selector: 'app-consumers-summary',
  templateUrl: './consumers-summary.component.html',
  styleUrls: ['./consumers-summary.component.scss']
})
export class ConsumersSummaryComponent implements OnInit {
  @Input() consumers: ConsumerModel[];

  constructor() {}

  ngOnInit(): void {}
}
